import { CSSProperties } from 'react';

import cn from 'classnames';

export type ProgressBarProps = {
  currentStepIndex: number;
  totalSteps: number;
  stepPercentage?: number;
};

export const ProgressBar = ({
  currentStepIndex,
  totalSteps,
  stepPercentage = 40,
}: ProgressBarProps) => {
  const steps = Array.from({ length: totalSteps }, (_, i) => i);

  return (
    <div
      role="progressbar"
      aria-valuenow={currentStepIndex}
      aria-valuemin={0}
      aria-valuemax={totalSteps}
      className="flex h-0.5 w-full gap-1 overflow-hidden"
    >
      {steps.map((step) => {
        const style: CSSProperties =
          step === currentStepIndex
            ? {
                background: `linear-gradient(
                to right,
                var(--color-accent-1) ${stepPercentage}%,
                var(--color-neutral-1) ${stepPercentage}% 100%
              )`,
              }
            : {};

        return (
          <div
            key={step}
            className={cn('w-full', {
              'bg-neutral-100': step >= currentStepIndex,
              'bg-accent-1!': step < currentStepIndex,
            })}
            style={style}
          />
        );
      })}
    </div>
  );
};
